export const COUNT_CATEGORIES_IN_DESCRIPTION = 5;
